import { FORM_LABELS } from '@oneapp/gst';
import type { FilingForm } from '@oneapp/shared';
import type { TFunction } from 'i18next';

/** "GSTR-3B"; and (gap 4b) "GSTR-1A", a filed month's fixes. */
export const formLabel = (form: FilingForm) => (form === 'gstr1a' ? 'GSTR-1A' : FORM_LABELS[form]);

/**
 * A return period as people say it: "August 2026", a quarter as "April to June 2026", a year as
 * "FY 2025–26". `period` is the period's last month (YYYY-MM).
 */
export function periodLabel(t: TFunction, period: string, kind: 'month' | 'quarter' | 'year'): string {
  const year = Number(period.slice(0, 4));
  const month = Number(period.slice(5, 7));
  if (kind === 'year') return `FY ${year - 1}–${String(year % 100).padStart(2, '0')}`;
  const name = (m: number) => t(`filings.months.${m}`);
  if (kind === 'quarter') return t('filings.quarter', { from: name(month - 2), to: name(month), year });
  return `${name(month)} ${year}`;
}
